import React from 'react';
import { Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { SplitView } from 'components/SplitView/SplitView';
import { TrackableItemDetail } from 'trackables/components/TrackableItemDetail/TrackableItemDetail';

export type DetailRouteWithTrackableItemRefProps = {
  children: React.ReactNode;
};

export function DetailRouteWithTrackableItemRef({
  children,
}: DetailRouteWithTrackableItemRefProps) {
  const { search } = useLocation();
  const navigate = useNavigate();

  function closeDetail(isOpen?: boolean) {
    if (!isOpen) {
      navigate({ pathname: '..', search });
    }
  }

  function closeItemDetail(isOpen?: boolean) {
    if (!isOpen) {
      navigate({ pathname: '.', search });
    }
  }

  return (
    <Routes>
      <Route
        path="*"
        element={
          <>
            <SplitView onOpenChange={closeDetail} easeOut open>
              {children}
            </SplitView>
            <Outlet />
          </>
        }
      >
        <Route
          path="items/:trackableItemId"
          element={
            <SplitView
              onOpenChange={closeItemDetail}
              easeOut
              isStacked
              open
            >
              <TrackableItemDetail />
            </SplitView>
          }
        />
      </Route>
    </Routes>
  );
}